<template>
    <div>
        <div class="page-title">Edit  Event</div>
        <div class="page-box">
            <eventStatusManageFrom ref="ruleForm" :ruleForm="ruleForm"></eventStatusManageFrom>
            <div class="page-button">
              <el-button type="warning" @click="onSubmit">Submit</el-button>
              <el-button  @click="onBack">Cancel</el-button>
            </div>
        </div>
         <loadingSlotDialog :centerDialogVisible="centerDialogVisible">
            <div class="dialog-title">Expire event</div>
            <div class="dialog-text">You are going to close the event of {{title}}. When the event is turned to expired, all the application will changed to inactive which means users cannot make any changes on the applicantion.Are you sure to expire the event?</div>
            <el-button  type="warning" @click="onConfirm">Confirm</el-button>
            <el-button @click="onCancel">Cancel</el-button>
         </loadingSlotDialog>
    </div>
</template>

<script>
    import loadingSlotDialog from '@/components/loadingSlotDialog'
    import {getEventStatusesDetail,editEventStatuses} from '@/api/admin/event-statuses'
    import eventStatusManageFrom from './components/eventStatusManageFrom.vue'
    export default {
        components:{eventStatusManageFrom,loadingSlotDialog},
        props:{
            id:{
                type:Number,
                default:0
            }
        },
        data() {
            return {
                title: "", 
                centerDialogVisible:false,
                ruleForm: {
                    title: "", 
                    type: null, 
                    registrationNo: null, 
                    startDate: "", 
                    endDate: "", 
                    isExpired: false, 
                    applicationNode: "",
                    level1:'',
                    level2:'',
                    level3:''
                },
            }
        },
        created(){
            this.getEventStatusesDetail()
        },
        methods:{
            onCancel(){
                this.centerDialogVisible = false
            },
            onConfirm(){
                this.editEventStatuses()
            },
            onSubmit(){
                 this.$refs.ruleForm.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        if(this.ruleForm.isExpired){
                        this.title = this.ruleForm.title
                        this.centerDialogVisible = true
                        } else {
                        this.editEventStatuses()
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
               
            },
            editEventStatuses(){
                editEventStatuses(this.id,this.ruleForm).then(()=>{
                    this.$router.push({path:'/admin/eventStatusManage'})
                })
            },
            getEventStatusesDetail(){
                getEventStatusesDetail(this.id).then((v)=>{
                     this.ruleForm = v.data
                })
            },
        }
        
    }
</script>

<style lang="scss" scoped>
.dialog-title{
    font-size: 20px;
}
.dialog-text{
  font-size: 16px;
}
.page-box{
    background-color: #fff;
    padding: 20px;
}
.page-button{
    text-align: right;
}
</style>